/** @graphql agg **/
import gql from 'graphql-tag';

import { getAGGClient } from '@confluence/graphql';

import {
	type FetchNativeCollabAGGUsersQuery as UsersQuery$data,
	type FetchNativeCollabAGGUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchNativeCollabAGGUsersQuery';

export const fetchNativeCollabAGGUsers = (accountIds: string[]) => {
	return getAGGClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchNativeCollabAGGUsersQuery($accountIds: [ID!]!) {
					users(accountIds: $accountIds) {
						accountId
						name
						picture
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.users
					?.filter((user) => user?.accountId)
					.map((user) => ({
						avatar: user.picture ?? '',
						email: '',
						name: user.name ?? '',
						userId: user.accountId,
					})) ?? []
			);
		});
};
